/**
 * Created by lihanying on 2017/6/29.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import { GETCLUBCOMMODITYTYPE } from './constants'

export const getClubCommodityType = (payload) => {
  return {
    type: GETCLUBCOMMODITYTYPE,
    payload,
  }
}

//商品分类
export function fetchClubCommodityType() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/CommodityTypeList`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubCommodityType(data.list))
      return data
    })
  }
}

//修改,添加,删除分类;
export function fetchSetCommodityType(a, body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/${a}`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchClubCommodityType())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodityType/action.js